export default __webpack_public_path__ + "static/rotate-zeta-c215bd921dc63b12c73610f20699609f.gif";